<template>
  <EditarBase
    nomeSingular="Usuario"
    nomePlural="Usuarios"
    form-autocomplete="off"
    :submitPersonalizado="true"
    @recurso="sincronizarRecurso($event)"
    @submitSuccess="emitSubmitSuccess"
    @submitError="emitSubmitError"
    @closeModalEdit="closeModalEdit"
  >
    <ErrorAlert :errors="errors" />
    <v-col cols="12">
      <v-row>
        <v-col cols="12">
          <span class="opacity-5 text-dark">
            {{ $t("Email_ou_cpf") }}
          </span>
          <v-text-field
            :label="$t('Email_ou_cpf')"
            v-model="recurso.email"
            disabled
            v-mask="maskEmailCpf(recurso.email)"
            class="
              input-style
              font-size-input
              text-light-input
              placeholder-light
              input-icon
            "
            dense
            flat
            filled
            solo
          />
        </v-col>
        <v-col cols="12">
          <div class="profile-access-panel">
            <div
              class="
                d-flex
                flex-wrap
                align-center
                justify-space-between
                mb-3
                profile-access-heading
              "
            >
              <span class="opacity-5 text-dark">
                {{ $t("Perfis_do_usuario") }}
              </span>
              <div class="profile-access-summary">
                <v-chip small class="ma-1" color="primary" text-color="white">
                  {{ perfisDetalhados.length }} {{ $t("Perfis") }}
                </v-chip>
                <v-chip small class="ma-1" color="success" text-color="white">
                  {{ totalPerfisPermanentes }} {{ $t("Permanentes") }}
                </v-chip>
                <v-chip small class="ma-1" color="warning" text-color="white">
                  {{ totalPerfisTemporarios }} {{ $t("Temporarios") }}
                </v-chip>
              </div>
            </div>

            <v-row dense align="start">
              <v-col cols="12" :md="possuiInquilinosReplicacao ? 5 : 9">
                <v-autocomplete
                  v-model="perfilParaAdicionar"
                  :items="perfisDisponiveis"
                  item-text="descricao"
                  return-object
                  :label="$t('Adicionar_perfil')"
                  prepend-inner-icon="mdi-account-key-outline"
                  class="
                    input-style
                    font-size-input
                    text-light-input
                    placeholder-light
                    input-icon
                  "
                  dense
                  flat
                  filled
                  solo
                  hide-details="auto"
                />
              </v-col>
              <v-col v-if="possuiInquilinosReplicacao" cols="12" md="4">
                <PerfilReplicacaoInquilinosSelect
                  v-model="inquilinosReplicacaoPerfilNovo"
                  :perfil-id="getPerfilId(perfilParaAdicionar)"
                  :inquilinos="inquilinosReplicacaoDisponiveis"
                />
              </v-col>
              <v-col cols="12" md="3" class="d-flex align-center">
                <v-btn
                  class="
                    font-weight-bold
                    text-none
                    btn-primary
                    bg-gradient-primary
                    px-4
                    profile-add-button
                  "
                  height="39"
                  block
                  :disabled="!perfilParaAdicionar"
                  @click="adicionarPerfil"
                >
                  <v-icon left>mdi-plus</v-icon>
                  {{ $t("Adicionar") }}
                </v-btn>
              </v-col>
            </v-row>

            <div v-if="perfisDetalhados.length === 0" class="profile-empty">
              <v-icon color="grey" class="mr-2">
                mdi-account-key-outline
              </v-icon>
              <span>{{ $t("Nenhum_perfil_selecionado") }}</span>
            </div>

            <div
              v-for="(item, index) in perfisDetalhados"
              :key="chavePerfil(item, index)"
              class="profile-access-row"
            >
              <div class="profile-access-row-title">
                <div class="profile-name">
                  {{ descricaoPerfil(item) }}
                </div>
                <v-chip
                  small
                  :color="corStatusPerfil(item)"
                  text-color="white"
                  class="profile-status-chip"
                >
                  {{ statusPerfil(item) }}
                </v-chip>
              </div>

              <div
                class="profile-access-row-controls"
                :class="{
                  'profile-access-row-controls--permanent': !item.temporario,
                }"
              >
                <v-switch
                  v-model="item.temporario"
                  :label="$t('Temporario')"
                  inset
                  dense
                  hide-details
                  class="profile-temporary-switch"
                  @change="onTemporarioChange(item)"
                />

                <v-text-field
                  v-if="item.temporario"
                  v-model="item.periodoInicio"
                  :label="$t('Periodo_inicio')"
                  type="date"
                  dense
                  flat
                  filled
                  solo
                  hide-details="auto"
                  class="
                    input-style
                    font-size-input
                    text-light-input
                    placeholder-light
                    input-icon
                    profile-date-field
                  "
                />

                <v-text-field
                  v-if="item.temporario"
                  v-model="item.periodoEncerramento"
                  :label="$t('Periodo_encerramento')"
                  type="date"
                  dense
                  flat
                  filled
                  solo
                  hide-details="auto"
                  class="
                    input-style
                    font-size-input
                    text-light-input
                    placeholder-light
                    input-icon
                    profile-date-field
                  "
                />

                <div class="profile-row-actions">
                  <v-tooltip v-if="possuiInquilinosReplicacao" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        :color="item.exibirReplicacao ? 'primary' : ''"
                        v-bind="attrs"
                        v-on="on"
                        :aria-label="tituloAcaoReplicacao(item)"
                        @click="alternarReplicacao(item)"
                      >
                        <v-icon>
                          {{
                            item.exibirReplicacao
                              ? "mdi-domain-remove"
                              : "mdi-domain-plus"
                          }}
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>{{ tituloAcaoReplicacao(item) }}</span>
                  </v-tooltip>

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        color="error"
                        v-bind="attrs"
                        v-on="on"
                        :aria-label="$t('Remover')"
                        @click="removerPerfil(index)"
                      >
                        <v-icon>mdi-delete-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t("Remover") }}</span>
                  </v-tooltip>
                </div>
              </div>

              <div
                v-if="possuiInquilinosReplicacao && item.exibirReplicacao"
                class="profile-replication"
              >
                <PerfilReplicacaoInquilinosSelect
                  v-model="item.inquilinosReplicacao"
                  :perfil-id="getPerfilId(item.perfil)"
                  :inquilinos="inquilinosReplicacaoDisponiveis"
                />
              </div>
            </div>
          </div>
        </v-col>

        <v-col cols="12">
          <InquilinosUsuarioPanel
            v-model="recurso.inquilinos"
            :items="itensInquilinos"
            :show-current-tenant-control="podeAlterarInquilinoAtual"
            :current-tenant-id="inquilinoAtualDestinoId"
            :current-tenant-items="itensInquilinosAtivos"
            :loading-current-tenant="loadingAlteracaoInquilino"
            :can-submit-current-tenant="podeEnviarAlteracaoInquilino"
            @update:currentTenantId="inquilinoAtualDestinoId = $event"
            @change-current-tenant="alterarInquilinoAtualUsuario"
          />
        </v-col>

        <v-col cols="12" md="6">
          <span class="opacity-5 text-dark">
            {{ $t("Status") }}
          </span>
          <v-select
            v-model="recurso.statusComum"
            :items="statusComumItems"
            item-text="text"
            item-value="value"
            label="Status comum"
            single-line
            class="
              input-style
              font-size-input
              text-light-input
              placeholder-light
              input-icon
            "
            dense
            flat
            filled
            solo
          ></v-select>
        </v-col>
        <v-col cols="12" md="6">
          <v-checkbox
            v-model="recurso.fullLog"
            class="font-size-input text-light-input placeholder-light"
            dense
            flat
            filled
            solo
          >
            <template v-slot:label>
              <p>{{ $t("Log_detalhado") }}</p>
            </template>
          </v-checkbox>
        </v-col>
        <v-col cols="12" md="6">
          <v-checkbox
            v-model="recurso.notificarLogin"
            class="font-size-input text-light-input placeholder-light"
            dense
            flat
            filled
            solo
          >
            <template v-slot:label>
              <p>{{ $t("Notificar_login_por_email") }}</p>
            </template>
          </v-checkbox>
        </v-col>
        <v-col cols="12" md="6">
          <v-checkbox
            v-model="recurso.autenticacaoDoisFatores"
            class="font-size-input text-light-input placeholder-light"
            dense
            flat
            filled
            solo
          >
            <template v-slot:label>
              <p>{{ $t("Autenticacao_dois_fatores") }}</p>
            </template>
          </v-checkbox>
        </v-col>

        <v-col cols="12" md="6">
          <span class="opacity-5 text-dark">
            {{ $t("Senha") }}
          </span>
          <v-text-field
            v-model="recurso.senha"
            :label="$t('Senha')"
            name="senha"
            type="password"
            class="
              input-style
              font-size-input
              text-light-input
              placeholder-light
              input-icon
            "
            dense
            flat
            filled
            solo
          />
        </v-col>

        <v-col cols="12" md="6">
          <span class="opacity-5 text-dark">
            {{ $t("confirme_a_senha") }}
          </span>
          <v-text-field
            v-model="senhaConfirma"
            :label="$t('confirme_a_senha')"
            name="senhaConfirma"
            type="password"
            class="
              input-style
              font-size-input
              text-light-input
              placeholder-light
              input-icon
            "
            dense
            flat
            filled
            solo
          />
        </v-col>

        <v-col cols="12" md="6" v-if="deveMostrarTetoOrcamento()">
          <v-text-field-money
            v-model="recurso.comprasTetoAprovacaoOrcamento"
            v-bind:label="$t('Compras_teto_aprovacao_orcamento')"
            v-bind:properties="{
              prefix: 'R$',
              readonly: false,
              disabled: false,
              outlined: false,
              clearable: true,
            }"
            v-bind:options="{
              locale: 'pt-BR',
              length: 12,
              precision: 2,
              empty: '0',
            }"
            class="font-size-input text-light-input placeholder-light"
            dense
            flat
            filled
            solo
          />
        </v-col>
        <v-col
          cols="4"
          md="4"
          v-if="
            this.$store.state.inquilino.parametrizacoes.find(
              (item) => item.tipo == 'MULTIPLOSCENTROSESTOQUE'
            )
          "
        >
          <span class="opacity-5 text-dark">
            {{ $t("CentroEstoque") }}
          </span>
          <v-autocomplete
            id="centroEstoque"
            outlined
            v-model="recurso.centroEstoque"
            :items="centrosEstoque"
            :item-text="(item) => item.descricao"
            :label="$t('CentroEstoque')"
            return-object
            class="
              input-style
              font-size-input
              text-light-input
              placeholder-light
              input-icon
            "
            dense
            flat
            filled
            solo
          >
          </v-autocomplete>
        </v-col>
      </v-row>
    </v-col>
  </EditarBase>
</template>

<script>
import EditarBase from "@/components/base/Crud/EditarBase";
import InquilinosUsuarioPanel from "@/components/acessos/Usuarios/InquilinosUsuarioPanel";
import PerfilReplicacaoInquilinosSelect from "@/components/acessos/Usuarios/PerfilReplicacaoInquilinosSelect";
import UsuarioDataService from "@/services/acessos/UsuarioDataService";
import ComumDataService from "@/services/ComumDataService";
import { normalizeApiErrors } from "@/utils/apiErrors";
const DataService = UsuarioDataService;

export default {
  name: "EditarUsuario",
  components: {
    EditarBase,
    InquilinosUsuarioPanel,
    PerfilReplicacaoInquilinosSelect,
  },
  props: {
    itemAtual: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      DataService: DataService,
      itensInquilinos: [],
      itensInquilinosUsuarioEditado: [],
      senhaConfirma: "",
      errors: [],
      inquilinoAtualDestinoId: null,
      loadingAlteracaoInquilino: false,
      perfilParaAdicionar: null,
      inquilinosReplicacao: [],
      inquilinosReplicacaoPerfilNovo: [],
      recurso: {
        email: "",
        statusComum: null,
        perfis: [],
        perfisInquilino: [],
        notificarLogin: false,
        autenticacaoDoisFatores: false,
      },
      centrosEstoque: [],
      todosPerfis: [],
      statusComumItems: [
        { text: "Ativo", value: "ATIVO" },
        { text: "Inativo", value: "INATIVO" },
      ],
    };
  },
  computed: {
    podeAlterarInquilinoAtual() {
      const permissoes = this.$store?.state?.permissoes || [];
      return permissoes.includes("ROLE_Usuario_ChangeTenant");
    },
    itensInquilinosAtivos() {
      const itens = Array.isArray(this.recurso?.inquilinos)
        ? this.recurso.inquilinos
        : this.itensInquilinosUsuarioEditado;
      return itens.filter((item) => {
        return this.getStatusInquilino(item) === "ATIVO";
      });
    },
    podeEnviarAlteracaoInquilino() {
      const destinoId = this.normalizarId(this.inquilinoAtualDestinoId);
      const atualId = this.normalizarId(this.recurso?.inquilino?.id);
      return (
        destinoId !== null &&
        destinoId !== atualId &&
        this.itensInquilinosAtivos.some((item) => {
          return this.normalizarId(this.getItemInquilinoId(item)) === destinoId;
        })
      );
    },
    perfisDetalhados() {
      return Array.isArray(this.recurso?.perfisInquilino)
        ? this.recurso.perfisInquilino
        : [];
    },
    perfisDisponiveis() {
      const selecionados = new Set(
        this.perfisDetalhados
          .map((item) => this.getPerfilId(item?.perfil))
          .filter((id) => id !== null && id !== undefined)
      );
      return this.todosPerfis.filter((perfil) => {
        return !selecionados.has(this.getPerfilId(perfil));
      });
    },
    // Inquilinos em que o usuário logado pode replicar perfis, restritos aos
    // inquilinos do usuário editado conforme o formulário
    inquilinosReplicacaoDisponiveis() {
      const idsInquilinosUsuario = new Set(
        this.normalizarInquilinosUsuario(this.recurso?.inquilinos).map((item) =>
          this.normalizarId(this.getItemInquilinoId(item))
        )
      );
      const atualId = this.normalizarId(this.recurso?.inquilino?.id);
      return this.inquilinosReplicacao
        .filter((inquilino) => {
          const id = this.normalizarId(inquilino.id);
          return id !== atualId && idsInquilinosUsuario.has(id);
        })
        .sort((a, b) =>
          this.nomeInquilinoReplicacao(a).localeCompare(
            this.nomeInquilinoReplicacao(b)
          )
        );
    },
    possuiInquilinosReplicacao() {
      return this.inquilinosReplicacaoDisponiveis.length > 0;
    },
    totalPerfisTemporarios() {
      return this.perfisDetalhados.filter((item) => !!item.temporario).length;
    },
    totalPerfisPermanentes() {
      return this.perfisDetalhados.filter((item) => !item.temporario).length;
    },
  },
  watch: {
    itemAtual: {
      immediate: true,
      handler(value) {
        if (!value) {
          return;
        }
        this.sincronizarRecurso(value);
      },
    },
    "recurso.inquilinos": {
      deep: true,
      handler() {
        this.sincronizarDestinoInquilinoAtual();
      },
    },
  },
  methods: {
    emitSubmitSuccess(recursoAtualizado = this.recurso) {
      this.$emit("submitSuccess", recursoAtualizado);
    },
    emitSubmitError() {
      this.$emit("submitError");
    },
    closeModalEdit() {
      this.$emit("closeModalEdit");
    },
    carregarInquilinosDisponiveis() {
      return UsuarioDataService.find(this.$store.state.user.id)
        .then((response) => {
          this.itensInquilinos = Array.isArray(response.data?.inquilinos)
            ? response.data.inquilinos
            : [];
        })
        .catch((error) => {
          console.log(error);
          this.itensInquilinos = this.$store?.state?.user?.inquilinos || [];
        });
    },
    submitForm() {
      return new Promise((resolve, reject) => {
        if (!this.senhaCoincide()) {
          reject();
          return;
        }
        if (!this.validarPerfisTemporarios()) {
          reject();
          return;
        }

        DataService.update(this.montarPayloadUsuario())
          .then(() => {
            console.log("entrou no .then");
            this.errors = [];
            this.limparReplicacoes();
            this.carregarInquilinosReplicacao();
            this.submited = true;
            resolve("");
          })
          .catch((error) => {
            console.log(error);
            window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
            reject(normalizeApiErrors(error, "Usuario"));
          });
      });
    },

    getRecurso() {
      const id = this.getRecursoId();
      if (!id) {
        return Promise.resolve();
      }
      return DataService.find(id)
        .then((response) => {
          this.recurso = this.normalizarRecursoUsuario(response.data);
          this.itensInquilinosUsuarioEditado = Array.isArray(
            response.data?.inquilinos
          )
            ? response.data.inquilinos
            : [];
          this.inquilinoAtualDestinoId = response.data?.inquilino?.id || null;
          this.sincronizarDestinoInquilinoAtual();
        })
        .catch((error) => {
          window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
          console.log(error);
          this.errors.push({ field: "ID", message: "Usuário não encontrado" });
        });
    },

    carregarInquilinosReplicacao() {
      const id = this.getRecursoId();
      if (!id) {
        return Promise.resolve();
      }
      return DataService.findInquilinosReplicacaoPerfis(id)
        .then((response) => {
          this.inquilinosReplicacao = Array.isArray(response.data)
            ? response.data
            : [];
        })
        .catch((error) => {
          console.log(error);
          this.inquilinosReplicacao = [];
        });
    },

    getRecursoId() {
      return this.recurso?.id || this.$route?.params?.id || null;
    },

    sincronizarRecurso(recurso) {
      this.recurso = this.normalizarRecursoUsuario({
        ...this.recurso,
        ...(recurso || {}),
      });
    },

    normalizarRecursoUsuario(recurso) {
      const origem = recurso || {};
      const perfisOrigem =
        Array.isArray(origem.perfisInquilino) && origem.perfisInquilino.length
          ? origem.perfisInquilino
          : Array.isArray(origem.perfis)
          ? origem.perfis
          : [];
      const perfisInquilino = perfisOrigem.map((item) =>
        this.normalizarPerfilInquilino(item, origem)
      );
      return {
        ...origem,
        notificarLogin:
          origem.notificarLogin !== undefined
            ? !!origem.notificarLogin
            : !!this.recurso?.notificarLogin,
        autenticacaoDoisFatores:
          origem.autenticacaoDoisFatores !== undefined
            ? !!origem.autenticacaoDoisFatores
            : !!this.recurso?.autenticacaoDoisFatores,
        perfisInquilino,
        perfis: perfisInquilino.map((item) => item.perfil),
      };
    },

    normalizarPerfilInquilino(item, recurso = this.recurso) {
      const perfil = item?.perfil || item || {};
      const temporario = !!item?.temporario;
      return {
        id: item?.id || null,
        perfil,
        inquilino:
          item?.inquilino || recurso?.inquilino || this.$store.state.inquilino,
        temporario,
        periodoInicio: temporario
          ? this.normalizarDataISO(item?.periodoInicio)
          : null,
        periodoEncerramento: temporario
          ? this.normalizarDataISO(item?.periodoEncerramento)
          : null,
        inquilinosReplicacao: Array.isArray(item?.inquilinosReplicacao)
          ? item.inquilinosReplicacao
          : [],
        exibirReplicacao: !!item?.exibirReplicacao,
      };
    },

    normalizarDataISO(data) {
      if (!data) {
        return null;
      }
      return String(data).substring(0, 10);
    },

    getPerfilId(perfil) {
      return perfil?.id ?? null;
    },

    getPerfilInquilinoId(item) {
      return item?.inquilino?.id || this.recurso?.inquilino?.id || null;
    },

    criarPerfilInquilino(perfil, inquilinosReplicacao = []) {
      return {
        id: null,
        perfil,
        inquilino: this.recurso?.inquilino || this.$store.state.inquilino,
        temporario: false,
        periodoInicio: null,
        periodoEncerramento: null,
        inquilinosReplicacao,
        exibirReplicacao: inquilinosReplicacao.length > 0,
      };
    },

    adicionarPerfil() {
      if (!this.perfilParaAdicionar) {
        return;
      }
      this.recurso.perfisInquilino.push(
        this.criarPerfilInquilino(this.perfilParaAdicionar, [
          ...this.inquilinosReplicacaoPerfilNovo,
        ])
      );
      this.perfilParaAdicionar = null;
      this.inquilinosReplicacaoPerfilNovo = [];
      this.sincronizarPerfisSimples();
    },

    alternarReplicacao(item) {
      item.exibirReplicacao = !item.exibirReplicacao;
      if (!item.exibirReplicacao) {
        item.inquilinosReplicacao = [];
      }
    },

    tituloAcaoReplicacao(item) {
      return item?.exibirReplicacao
        ? this.$t("Cancelar_replicacao")
        : this.$t("Replicar_em_outros_inquilinos");
    },

    limparReplicacoes() {
      this.perfisDetalhados.forEach((item) => {
        item.inquilinosReplicacao = [];
        item.exibirReplicacao = false;
      });
      this.inquilinosReplicacaoPerfilNovo = [];
    },

    nomeInquilinoReplicacao(inquilino) {
      return (
        inquilino?.fantasia || inquilino?.razaoSocial || `#${inquilino?.id}`
      );
    },

    montarPerfisReplicacao() {
      const idsDisponiveis = new Set(
        this.inquilinosReplicacaoDisponiveis.map((inquilino) =>
          this.normalizarId(inquilino.id)
        )
      );
      return this.perfisDetalhados
        .map((item) => ({
          idPerfil: this.getPerfilId(item.perfil),
          idsInquilinos: (item.inquilinosReplicacao || []).filter((id) =>
            idsDisponiveis.has(this.normalizarId(id))
          ),
        }))
        .filter((item) => item.idPerfil !== null && item.idsInquilinos.length);
    },

    removerPerfil(index) {
      this.recurso.perfisInquilino.splice(index, 1);
      this.sincronizarPerfisSimples();
    },

    sincronizarPerfisSimples() {
      this.recurso.perfis = this.perfisDetalhados.map((item) => item.perfil);
    },

    onTemporarioChange(item) {
      if (!item.temporario) {
        item.periodoInicio = null;
        item.periodoEncerramento = null;
        return;
      }
      const hoje = this.dataAtualISO();
      if (!item.periodoInicio) {
        item.periodoInicio = hoje;
      }
      if (!item.periodoEncerramento) {
        item.periodoEncerramento = hoje;
      }
    },

    dataAtualISO() {
      const data = new Date();
      const ano = data.getFullYear();
      const mes = String(data.getMonth() + 1).padStart(2, "0");
      const dia = String(data.getDate()).padStart(2, "0");
      return `${ano}-${mes}-${dia}`;
    },

    descricaoPerfil(item) {
      return item?.perfil?.descricao || "";
    },

    statusPerfil(item) {
      if (!item?.temporario) {
        return this.$t("Permanente");
      }
      const hoje = this.dataAtualISO();
      if (item.periodoEncerramento && item.periodoEncerramento < hoje) {
        return this.$t("Encerrado");
      }
      if (item.periodoInicio && item.periodoInicio > hoje) {
        return this.$t("Agendado");
      }
      return this.$t("Temporario");
    },

    corStatusPerfil(item) {
      if (!item?.temporario) {
        return "success";
      }
      const hoje = this.dataAtualISO();
      if (item.periodoEncerramento && item.periodoEncerramento < hoje) {
        return "error";
      }
      if (item.periodoInicio && item.periodoInicio > hoje) {
        return "info";
      }
      return "warning";
    },

    chavePerfil(item, index) {
      return `${this.getPerfilId(item?.perfil) || "novo"}-${
        this.getPerfilInquilinoId(item) || "inq"
      }-${index}`;
    },

    validarPerfisTemporarios() {
      const erros = [];
      this.perfisDetalhados.forEach((item) => {
        if (!item.temporario) {
          return;
        }
        const descricao = this.descricaoPerfil(item);
        if (!item.periodoInicio || !item.periodoEncerramento) {
          erros.push({
            fieldName: descricao || this.$t("Perfis_do_usuario"),
            message: this.$t(
              "Perfil_temporario_exige_periodo_inicio_encerramento"
            ),
          });
          return;
        }
        if (item.periodoInicio > item.periodoEncerramento) {
          erros.push({
            fieldName: descricao || this.$t("Perfis_do_usuario"),
            message: this.$t("Periodo_invalido"),
          });
        }
      });
      if (erros.length > 0) {
        this.errors = erros;
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
        return false;
      }
      return true;
    },

    montarPayloadUsuario() {
      const inquilinos = this.normalizarInquilinosUsuario(
        this.recurso.inquilinos
      );
      const perfisInquilino = this.perfisDetalhados.map((item) => {
        const temporario = !!item.temporario;
        return {
          id: item.id || null,
          perfil: item.perfil,
          inquilino:
            item.inquilino ||
            this.recurso?.inquilino ||
            this.$store.state.inquilino,
          temporario,
          periodoInicio: temporario ? item.periodoInicio : null,
          periodoEncerramento: temporario ? item.periodoEncerramento : null,
        };
      });

      return {
        id: this.recurso.id,
        email: this.recurso.email,
        imagem: this.recurso.imagem,
        imagem64: this.recurso.imagem64,
        perfis: perfisInquilino.map((item) => item.perfil),
        perfisInquilino,
        perfisReplicacao: this.montarPerfisReplicacao(),
        inquilinos,
        fullLog: this.recurso.fullLog,
        notificarLogin: this.recurso.notificarLogin,
        autenticacaoDoisFatores: this.recurso.autenticacaoDoisFatores,
        senha: this.recurso.senha,
        statusComum: this.recurso.statusComum,
        comprasTetoAprovacaoOrcamento:
          this.recurso.comprasTetoAprovacaoOrcamento,
        centroEstoque: this.recurso.centroEstoque,
      };
    },

    getItemInquilinoId(item) {
      return item?.inquilino?.id || item?.id || null;
    },

    normalizarInquilinosUsuario(inquilinos) {
      return (Array.isArray(inquilinos) ? inquilinos : [])
        .filter((item) => this.getItemInquilinoId(item))
        .map((item) => {
          return item?.inquilino ? item : { inquilino: item };
        });
    },

    getStatusInquilino(item) {
      return item?.inquilino?.statusComum || item?.statusComum || "";
    },

    normalizarId(id) {
      if (id === null || id === undefined || id === "") {
        return null;
      }
      return String(id);
    },

    sincronizarDestinoInquilinoAtual() {
      if (!this.podeAlterarInquilinoAtual) {
        return;
      }

      const idsAtivos = this.itensInquilinosAtivos
        .map((item) => this.normalizarId(this.getItemInquilinoId(item)))
        .filter((id) => id !== null);
      const destinoId = this.normalizarId(this.inquilinoAtualDestinoId);
      if (destinoId && idsAtivos.includes(destinoId)) {
        return;
      }

      const atualId = this.normalizarId(this.recurso?.inquilino?.id);
      if (atualId && idsAtivos.includes(atualId)) {
        this.inquilinoAtualDestinoId = this.recurso.inquilino.id;
        return;
      }

      this.inquilinoAtualDestinoId = this.getItemInquilinoId(
        this.itensInquilinosAtivos[0]
      );
    },

    alterarInquilinoAtualUsuario() {
      if (
        !this.podeEnviarAlteracaoInquilino ||
        this.loadingAlteracaoInquilino
      ) {
        return;
      }
      this.loadingAlteracaoInquilino = true;
      DataService.changeTenant(this.recurso.id, this.inquilinoAtualDestinoId)
        .then(() => {
          this.$swal.fire(
            this.$t("Sucesso"),
            this.$t("Empresa_alterada_com_sucesso"),
            "success"
          );
          this.closeModalEdit();
        })
        .catch((error) => {
          console.log(error);
          this.$swal.fire(
            this.$t("Erro"),
            this.$t("Falha_ao_alterar_empresa"),
            "error"
          );
          this.inquilinoAtualDestinoId = this.recurso?.inquilino?.id || null;
        })
        .finally(() => {
          this.loadingAlteracaoInquilino = false;
        });
    },

    findPerfis() {
      DataService.findPerfis()
        .then((response) => {
          this.todosPerfis = response.data;
        })
        .catch((error) => {
          window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
          console.log(error);
        });
    },

    senhaCoincide() {
      if (
        this.recurso.senha !== this.senhaConfirma &&
        this.recurso.senha !== null &&
        this.recurso.senha?.length > 0
      ) {
        this.errors = [
          { field: this.$t("Senha"), message: this.$t("senhas_nao_conferem") },
        ];
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
        return false;
      }
      return true;
    },

    deveMostrarTetoOrcamento() {
      return this.$store.state.inquilino.modulosContratacao.find((item) => {
        return item.tipo == "COMPRAS";
      });
    },

    getCentrosEstoque() {
      ComumDataService.get("centroEstoques").then((res) => {
        this.centrosEstoque = res.data;
      });
    },
  },
  mounted() {
    const id = this.getRecursoId();
    if (id && !this.recurso?.id) {
      this.recurso = {
        ...this.recurso,
        id,
      };
    }
    this.recurso.notificarLogin = !!this.recurso?.notificarLogin;
    this.recurso.autenticacaoDoisFatores =
      !!this.recurso?.autenticacaoDoisFatores;
    this.itensInquilinosUsuarioEditado = this.recurso?.inquilinos || [];
    this.inquilinoAtualDestinoId = this.recurso?.inquilino?.id || null;
    this.carregarInquilinosDisponiveis();
    this.getRecurso();
    this.carregarInquilinosReplicacao();

    this.findPerfis();

    if (
      this.$store.state.inquilino.parametrizacoes.find(
        (item) => item.tipo == "MULTIPLOSCENTROSESTOQUE"
      )
    ) {
      this.getCentrosEstoque();
    }
  },
};
</script>

<style scoped>
.profile-access-panel {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 16px;
  background: #ffffff;
}

.profile-access-heading {
  gap: 8px;
}

.profile-access-summary {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.profile-add-button {
  min-width: 100%;
}

.profile-empty {
  align-items: center;
  background: #f8fafc;
  border: 1px dashed #cbd5e1;
  border-radius: 8px;
  color: #64748b;
  display: flex;
  font-size: 0.875rem;
  justify-content: center;
  margin-top: 12px;
  min-height: 56px;
}

.profile-access-row {
  align-items: center;
  border-top: 1px solid #eef2f7;
  display: grid;
  gap: 12px;
  grid-template-columns: minmax(180px, 1fr) minmax(420px, 2fr);
  padding: 14px 0 4px;
}

.profile-access-row:first-of-type {
  border-top: 0;
}

.profile-access-row-title {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  min-width: 0;
}

.profile-name {
  color: #1f2937;
  font-size: 0.95rem;
  font-weight: 600;
  overflow-wrap: anywhere;
}

.profile-status-chip {
  flex: 0 0 auto;
}

.profile-access-row-controls {
  align-items: center;
  display: grid;
  gap: 10px;
  grid-template-columns:
    minmax(130px, 0.8fr) minmax(140px, 1fr) minmax(140px, 1fr)
    auto;
}

.profile-access-row-controls--permanent {
  grid-template-columns: minmax(130px, 1fr) auto;
}

.profile-row-actions {
  align-items: center;
  display: flex;
  justify-content: flex-end;
}

.profile-replication {
  grid-column: 1 / -1;
}

.profile-temporary-switch {
  margin-top: 0;
}

.profile-date-field {
  min-width: 0;
}

@media (max-width: 960px) {
  .profile-access-row {
    grid-template-columns: 1fr;
  }

  .profile-access-row-controls {
    grid-template-columns: 1fr;
  }

  .profile-access-summary {
    justify-content: flex-start;
  }
}
</style>
